// Vertical Slider JavaScript

class VerticalSlider {
  constructor() {
    this.swiperInstance = null;
    this.startOnFooter = this.shouldStartOnFooter();
    this.init();
  }

  shouldStartOnFooter() {
    const params = new URLSearchParams(window.location.search);
    const posted = params.get('contact_posted') === 'true';
    const isContactHash = window.location.hash === '#contact_form';
    if (!posted && !isContactHash) {
      return false;
    }
    if (window.location.hash) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }
    window.scrollTo(0, 0);
    return true;
  }

  init() {
    if (typeof Swiper === 'undefined') {
      this.loadSwiper(() => {
        this.setupSlider();
      });
    } else {
      this.setupSlider();
    }
  }

  loadSwiper(callback) {
    const swiperCSS = document.createElement('link');
    swiperCSS.rel = 'stylesheet';
    swiperCSS.href = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.css';
    document.head.appendChild(swiperCSS);

    const swiperJS = document.createElement('script');
    swiperJS.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
    swiperJS.onload = callback;
    document.head.appendChild(swiperJS);
  }

  setupSlider() {
    const sections = this.findSections();
    if (sections.length === 0) {
      document.body.classList.add('vertical-slider-ready');
      return;
    }
    this.createSliderStructure(sections);
    this.initializeSwiper();
  }

  findSections() {
    const allSections = document.querySelectorAll('.shopify-section');
    const excludePatterns = [
      'popup',
      'location',
      'header',
      'navigation',
      'nav',
      'menu',
      'cart-notification',
      'cart-live-region',
      'predictive-search'
    ];
    const validSections = [];
    allSections.forEach(section => {
      const sectionId = section.id || '';
      const sectionClass = section.className || '';
      const sectionContent = sectionId + ' ' + sectionClass;
      const shouldExclude = excludePatterns.some(pattern => 
        sectionContent.toLowerCase().includes(pattern.toLowerCase())
      );
      if (shouldExclude) {
        return;
      }
      const rect = section.getBoundingClientRect();
      const isVisible = rect.height > 0 && 
                       getComputedStyle(section).display !== 'none' &&
                       getComputedStyle(section).visibility !== 'hidden';
      if (!isVisible) {
        return;
      }
      if (section.children.length === 0) {
        return;
      }
      validSections.push(section);
    });
    return validSections;
  }

  createSliderStructure(sections) {
    if (sections.length === 0) return;
    document.body.classList.add('vertical-slider-enabled');
    const sliderContainer = document.createElement('div');
    sliderContainer.className = 'vertical-slider-container';
    const swiperContainer = document.createElement('div');
    swiperContainer.className = 'swiper vertical-slider-swiper';
    const swiperWrapper = document.createElement('div');
    swiperWrapper.className = 'swiper-wrapper';
    const parent = sections[0].parentNode;
    sections.forEach((section, index) => {
      const slide = document.createElement('div');
      slide.className = 'swiper-slide';
      slide.setAttribute('data-slide-index', index);
      section.parentNode.removeChild(section);
      slide.appendChild(section);
      swiperWrapper.appendChild(slide);
    });
    swiperContainer.appendChild(swiperWrapper);
    sliderContainer.appendChild(swiperContainer);
    parent.appendChild(sliderContainer);
    this.sliderContainer = sliderContainer;
    this.swiperContainer = swiperContainer;
  }

  initializeSwiper() {
    if (!this.swiperContainer) {
      return;
    }
    // Saint Laurent style - no standard swiper effects
    const swiperConfig = {
      direction: 'vertical',
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 0, // Instant transitions, we handle animation manually
      allowTouchMove: false, // Disable touch, use custom scroll
      mousewheel: false, // Disable default mousewheel
      keyboard: false, // Disable default keyboard
      pagination: false,
      navigation: false,
      scrollbar: false,
      on: {
        init: () => {
          this.setupSaintLaurentLayout();
          this.bindCustomScrolling();
        }
      }
    };
    this.currentSlide = 0;
    this.isAnimating = false;
    this.swiperInstance = new Swiper(this.swiperContainer, swiperConfig);
  }

  setupSaintLaurentLayout() {
    const slides = this.swiperContainer.querySelectorAll('.swiper-slide');
    // Get actual viewport height for mobile
    const vh = window.innerHeight;
    let startIndex = 0;
    if (this.startOnFooter) {
      const contactSlide = document.querySelector('#contact_form');
      const footerSlide = contactSlide ? contactSlide.closest('.swiper-slide') : null;
      if (footerSlide) {
        const idx = Array.from(slides).indexOf(footerSlide);
        if (idx > 0) {
          startIndex = idx;
        }
      }
    }
    slides.forEach((slide, index) => {
      slide.style.height = vh + 'px'; // Use actual viewport height
      slide.style.minHeight = vh + 'px';
      slide.style.position = 'absolute';
      slide.style.top = '0';
      slide.style.left = '0';
      slide.style.width = '100%';
      slide.style.transformOrigin = 'center center';
      slide.style.backfaceVisibility = 'hidden';
      slide.style.willChange = 'transform';
      slide.style.transitionProperty = 'transform';
        slide.style.transitionDuration = '300ms';
      slide.style.transitionTimingFunction = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      // Force same transition on all child elements that might have different timing
      const childElements = slide.querySelectorAll('*');
      childElements.forEach(child => {
          child.style.transitionDuration = '300ms';
        child.style.transitionTimingFunction = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      });
      // Force sections inside slides to fill viewport
      const section = slide.querySelector('.shopify-section');
      if (section) {
        section.style.height = vh + 'px';
        section.style.minHeight = vh + 'px';
      }
      if (index <= startIndex) {
        slide.style.transform = 'translate3d(0, 0, 0)';
        slide.style.zIndex = 1000 + index;
        if (index === startIndex) {
          slide.classList.add('swiper-slide-active', 'swiper-slide-visible');
        }
      } else {
        slide.style.zIndex = slides.length - index;
        const translateY = `${100 + (index - startIndex - 1) * 100}vh`;
        slide.style.transform = `translate3d(0, ${translateY}, 0)`;
      }
      // Force reflow to ensure styles are applied
      slide.offsetHeight;
    });
    this.totalSlides = slides.length;
    this.currentSlide = startIndex;
    this.updateHeaderState();
  }

  updateHeaderState() {
    const onFooter = this.currentSlide === this.totalSlides - 1;
    document.body.classList.toggle('slider-on-footer', onFooter);
    const slides = this.swiperContainer.querySelectorAll('.swiper-slide');
    const isDark = this.isSlideDark(slides[this.currentSlide]);
    document.body.classList.toggle('slider-header-dark', isDark);
    document.body.classList.toggle('slider-header-light', !isDark);
  }

  isSlideDark(slide) {
    if (!slide) {
      return true;
    }
    if (slide.querySelector('.video-hero, .image-hero, .slideshow')) {
      return true;
    }
    const section = slide.querySelector('.section') || slide.querySelector('.shopify-section');
    if (!section) {
      return true;
    }
    if (section.classList.contains('section--contrast')) {
      return true;
    }
    const rgb = window.getComputedStyle(section).backgroundColor.match(/[\d.]+/g);
    if (!rgb || rgb.length < 3) {
      return true;
    }
    const alpha = rgb[3] !== undefined ? parseFloat(rgb[3]) : 1;
    if (alpha === 0) {
      return true;
    }
    const luminance = 0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2];
    return luminance < 128;
  }

  bindCustomScrolling() {
    let debounceTimeout;
    let lastDirection = 0;
    const DEBOUNCE_TIME = 30;
    const container = this.sliderContainer;

    const blockPointerEvents = () => {
      container.style.pointerEvents = 'none';
    };
    const unblockPointerEvents = () => {
      container.style.pointerEvents = 'auto';
    };

    const handleWheel = (e) => {
      e.preventDefault();
      if (this.isAnimating) {
        return;
      }
      // Store current direction
      const direction = e.deltaY > 0 ? 1 : -1;
      lastDirection = direction;
      // Clear previous timeout
      if (debounceTimeout) {
        clearTimeout(debounceTimeout);
      }
      // Set new timeout - will only execute after wheel events stop
      debounceTimeout = setTimeout(() => {
        if (this.isAnimating) {
          return;
        }
        blockPointerEvents();
        if (lastDirection > 0 && this.currentSlide < this.totalSlides - 1) {
          this.pullSlideUp(this.currentSlide + 1);
        } else if (lastDirection < 0 && this.currentSlide > 0) {
          this.pushSlideDown(this.currentSlide);
        } else if (lastDirection > 0 && this.currentSlide === this.totalSlides - 1 && this.currentSlide > 0) {
          this.pushSlideDown(this.currentSlide);
        }
        setTimeout(unblockPointerEvents, 650);
      }, DEBOUNCE_TIME);
    };
    
    // Bind wheel event to container
    this.sliderContainer.addEventListener('wheel', handleWheel, { passive: false });
    
    // Also bind to document to catch events that might be blocked  
    document.addEventListener('wheel', (e) => {
      if (this.sliderContainer.contains(e.target)) {
        handleWheel(e);
      }
    }, { passive: false });
    
    // Touch support for mobile
    let touchStartY = 0;
    let touchEndY = 0;
    this.sliderContainer.addEventListener('touchstart', (e) => {
      touchStartY = e.touches[0].clientY;
    });
    this.sliderContainer.addEventListener('touchend', (e) => {
      if (this.isAnimating) return;
      blockPointerEvents();
      touchEndY = e.changedTouches[0].clientY;
      const diff = touchStartY - touchEndY;
      if (Math.abs(diff) > 50) {
        if (diff > 0 && this.currentSlide < this.totalSlides - 1) {
          this.pullSlideUp(this.currentSlide + 1);
        } else if (diff < 0 && this.currentSlide > 0) {
          this.pushSlideDown(this.currentSlide);
        } else if (diff > 0 && this.currentSlide === this.totalSlides - 1 && this.currentSlide > 0) {
          this.pushSlideDown(this.currentSlide);
        }
        setTimeout(unblockPointerEvents, 650);
      } else {
        unblockPointerEvents();
      }
    });
  }

  pullSlideUp(slideIndex) {
    if (this.isAnimating) {
      // Force reset if stuck
      setTimeout(() => {
        if (this.isAnimating) {
          this.isAnimating = false;
        }
      }, 100);
      return;
    }
    if (slideIndex >= this.totalSlides) {
      return;
    }
    this.isAnimating = true;
    const slides = this.swiperContainer.querySelectorAll('.swiper-slide');
    const targetSlide = slides[slideIndex];
    const currentSlide = slides[this.currentSlide];
    if (!targetSlide) {
      this.isAnimating = false;
      return;
    }
    // Force consistent transition timing
      targetSlide.style.transitionDuration = '300ms';
    targetSlide.style.transitionTimingFunction = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      currentSlide.style.transitionDuration = '300ms';
    currentSlide.style.transitionTimingFunction = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    // Remove active classes from current but leave it at 0,0,0 (Saint Laurent logic)
    currentSlide.classList.remove('swiper-slide-active', 'swiper-slide-visible');
    // Pull the target slide up to cover the screen and make it active
    targetSlide.style.transform = 'translate3d(0, 0, 0)';
    targetSlide.classList.add('swiper-slide-active', 'swiper-slide-visible');
    targetSlide.style.pointerEvents = 'auto';
    // Disable pointer events on previous slide
    currentSlide.style.pointerEvents = 'none';
    // Simple z-index: active slide gets highest z-index
    targetSlide.style.zIndex = 1000 + slideIndex;
    // Update current slide index
    this.currentSlide = slideIndex;
    this.updateHeaderState();
    // Reset animation flag after transition
      setTimeout(() => {
        this.isAnimating = false;
      }, 300); // Shorter timeout
  }

  pushSlideDown(slideIndex) {
    if (this.isAnimating) {
      // Force reset if stuck
      setTimeout(() => {
        if (this.isAnimating) {
          this.isAnimating = false;
        }
      }, 100);
      return;
    }
    if (slideIndex <= 0) {
      return;
    }
    this.isAnimating = true;
    const slides = this.swiperContainer.querySelectorAll('.swiper-slide');
    const currentSlide = slides[slideIndex];
    const prevSlide = slides[slideIndex - 1];
    // Force consistent transition timing
      currentSlide.style.transitionDuration = '300ms';
    currentSlide.style.transitionTimingFunction = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      prevSlide.style.transitionDuration = '300ms'; 
    prevSlide.style.transitionTimingFunction = 'cubic-bezier(0.25, 0.46, 0.45, 0.94)';
    // Push current slide back to its stack position
    const translateY = `${100 + (slideIndex - 1) * 100}vh`;
    currentSlide.style.transform = `translate3d(0, ${translateY}, 0)`;
    currentSlide.classList.remove('swiper-slide-active', 'swiper-slide-visible');
    // Previous slide is already at 0,0,0 - just make it active
    prevSlide.classList.add('swiper-slide-active', 'swiper-slide-visible');
    prevSlide.style.pointerEvents = 'auto';
    // Disable pointer events on current slide  
    currentSlide.style.pointerEvents = 'none';
    // Simple z-index: active slide gets highest z-index
    prevSlide.style.zIndex = 1000 + (slideIndex - 1);
    // Update current slide index
    this.currentSlide = slideIndex - 1;
    this.updateHeaderState();
    // Reset animation flag after transition
      setTimeout(() => {
        this.isAnimating = false;
      }, 300); // Shorter timeout
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new VerticalSlider();
});